import { Box, Stack, Tabs } from '@mui/material';
import { type SyntheticEvent, useState } from 'react';
import { PlansTab } from 'src/pages/Settings/memberships/components/plans-tab/plans-tab';
import { StyleTab } from 'src/pages/Settings/memberships/components/style-tab';
import { MembershipsConfigTab } from 'src/pages/Settings/memberships/styled';
import {
  configTabsHeaderSx,
  configTabsRootSx,
  configTabsSlotProps,
} from 'src/pages/Settings/memberships/styles';
import { TabValues } from 'src/pages/Settings/memberships/types';

type TabValue = TabValues;

interface ConfigTabsProps {
  onTabChange?: (tabIndex: TabValue) => void;
  readOnly: boolean;
}

export const ConfigTabs = ({ onTabChange, readOnly }: ConfigTabsProps) => {
  const [activeTab, setActiveTab] = useState<TabValue>(TabValues.Plans);

  const handleTabChange = (_: SyntheticEvent, nextTab: TabValue) => {
    if (nextTab === activeTab) {
      return;
    }
    setActiveTab(nextTab);
    onTabChange?.(nextTab);
  };

  return (
    <Stack height="100%" flex={1} direction="column">
      <Box sx={configTabsHeaderSx}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="standard"
          slotProps={configTabsSlotProps}
          sx={configTabsRootSx}
        >
          <MembershipsConfigTab label="Plans" value={TabValues.Plans} />
          <MembershipsConfigTab label="Style" value={TabValues.Style} />
        </Tabs>
      </Box>

      <Box flex={1} overflow="auto" py={2}>
        {activeTab === TabValues.Plans ? <PlansTab readOnly={readOnly} /> : null}

        {activeTab === TabValues.Style ? <StyleTab readOnly={readOnly} /> : null}
      </Box>
    </Stack>
  );
};
